<script lang="ts">
    import { onMount } from 'svelte'
    import Content from './content.svelte'

    onMount(async () => {
        await loadAppData()
    })

    let appData: { x64: { link; linkFull }; x86: { link; linkFull } } = null

    async function loadAppData() {
        appData = await window.api.brokers.channels.getAppData()
        if (!appData?.x64?.linkFull) {
            appData['x64']['linkFull'] = 'https://appzanducombr.s3.sa-east-1.amazonaws.com/ZanduWindows_Setup_32_x64.exe'
        }
        if (!appData?.x86?.linkFull) {
            appData['x86']['linkFull'] = 'https://appzanducombr.s3.sa-east-1.amazonaws.com/ZanduWindows_Setup_32_x86.exe'
        }
    }

    let bitness = 0
    let highConfidenceBitness = false
    async function isWinX64() {
        try {
            // @ts-ignore
            bitness = (await navigator.userAgentData?.getHighEntropyValues(['bitness']))?.bitness
            //if (bitness) highConfidenceBitness = true
            console.log('bitness', bitness)
        } catch (error) {
            if (navigator.userAgent.indexOf('WOW64') != -1 || navigator.userAgent.indexOf('Win64') != -1) {
                bitness = 64
            } else {
                bitness = 32
            }
        }
    }

    isWinX64()
</script>

<Content footer={true}>
    <div class="config-box mt-3 text-muted">
        Mantenha o Zandu Comunicação atualizado em seu computador para não ter interrupção no envio de mensagens.<br />
        {#if bitness !== 32}
            <a class="btn btn-primary mt-2" target="_blank" href={appData?.x64?.linkFull}>Baixar Zandu Comunicação - Windows 64 bits</a>
            {#if !highConfidenceBitness}
                <br />
                <a class="btn btn-link mt-1" target="_blank" href={appData?.x86?.linkFull}>Versão Windows 32 bits</a>
            {/if}
        {:else}
            <a class="btn btn-primary mt-2" target="_blank" href={appData?.x86?.linkFull}>Baixar Zandu Comunicação - Windows 32 bits</a>
            {#if !highConfidenceBitness}
                <br />
                <a class="btn btn-link mt-1" target="_blank" href={appData?.x64?.linkFull}>Versão Windows 64 bits</a>
            {/if}
        {/if}

        <div class="mt-3">
            <h5>instruções</h5>
            1. Estando EM SEU COMPUTADOR WINDOWS, Clique no botão verde acima e salve o arquivo;<br class="mb-2" />
            2. Quando o download concluir execute o arquivo;<br class="mb-2" />
            3. Caso veja a caixa azul abaixo siga as instruções da imagem:<br class="mb-2" />
            <img class="mb-2" src="/img/dh_01.webp" /><br class="mb-2" />
            4. O instalador irá abrir. Basta clicar em "Avançar" e depois em "Instalar";<br class="mb-2" />
            5. Após a instalação terminar clique em "Concluir";<br class="mb-2" />
            6. O Zandu Comunicação abrirá automaticamente. Caso não abra, procure em sua área de trabalho por "Zandu Comunicação";<br class="mb-2" />
            7. Com o Zandu Comunicação aberto faça login caso seja solicitado.<br />
        </div>
    </div>
</Content>

<style>
    .config-box {
        max-width: 980px;
        margin-left: auto;
        margin-right: auto;
    }
    .config-box img {
        display: inline-block;
    }
</style>
